// extracted by mini-css-extract-plugin
export default {"page":"SecureSettings_page__CJBNO","content":"SecureSettings_content__Lx6su"};